
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class BbwzTable extends Vue {
    //百变五张
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: ' 庄牌(金花)',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer_zjh.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: ' 庄牌(牛牛)',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer_bull.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '天(金花)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.fu_zjh) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.fu_zjh.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.fu_zjh.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '地(金花)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.lu_zjh) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.lu_zjh.bet, 1)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.lu_zjh.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '人(金花)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.shou_zjh) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.shou_zjh.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.shou_zjh.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '天(牛牛)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.fu_bull) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.fu_bull.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.fu_bull.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '地(牛牛)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.lu_bull) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.lu_bull.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.lu_bull.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '人(牛牛)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.shou_bull) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.shou_bull.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.shou_bull.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px',
                                    fontSize: '16px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px',
                                marginLeft: '8px',
                                display: poker.length ? 'block' : 'none'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;position: absolute;top:0;left:" + index * 12 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'dealer',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'dealer',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h('span', { style: { color: color } }, str)
                }
            }
        ]
    }

    @Prop()
    listdata
}
